import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const getValidateStatus = (err) => (err ? 'error' : undefined);
const getHelp = (err) => (err ? err : undefined);

const FormItem = ({ className, help, validateStatus, error, ...props }) => {
  return (
    <Form.Item
      {...props}
      className={cn(styles.root, className)}
      validateStatus={validateStatus ?? getValidateStatus(error)}
      help={help ?? getHelp(error)}
    />
  );
};

export default FormItem;
